import React from 'react';
import {Box} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';

const useStyles = makeStyles({
    overflow: {
        overflow: 'hidden',
    },
})

const GridContainer = ({children, ...props}) => {
    const styles = useStyles();

    return (
        <Box className={styles.overflow} {...props}>
            {children}
        </Box>
    )
};
export default GridContainer;
